import { getShopRendererApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class ShopRendererDraftNavigationApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getNavigation = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/themes/${pathParams.draft_theme_id}/navigations/${pathParams.navigation_handle}`);
        };
        this.createNavigationLink = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/links`, requestBody);
        };
        this.updateNavigationLink = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/links/${pathParams.draft_link_id}`, requestBody);
        };
        this.deleteNavigationLink = (pathParams) => {
            return this.delete(`/shops/${pathParams.shop_id}/drafts/links/${pathParams.draft_link_id}`);
        };
        this.reorderNavigationLink = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/links/${pathParams.draft_link_id}/reorder`, requestBody);
        };
    }
}
export const ShopRendererDraftNavigationApiClient = new ShopRendererDraftNavigationApiClientModel(getShopRendererApiUrl('api'));
